var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0.01 0.02 14.06 14.06", fill: "none" }, props),
    React.createElement("path", { d: "M7.047 4.547v2.5m0 2.5h.006m-5.636.213c.092.232.112.486.058.73L.81 12.546a.625.625 0 0 0 .772.73l2.133-.624a1.25 1.25 0 0 1 .687.058 6.25 6.25 0 1 0-2.985-2.95z", stroke: "#848484", strokeWidth: "1.594", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});